import { render } from "./TableFourColumn.vue?vue&type=template&id=130dc225"
import script from "./TableFourColumn.vue?vue&type=script&lang=js"
export * from "./TableFourColumn.vue?vue&type=script&lang=js"

import "./TableFourColumn.vue?vue&type=style&index=0&id=130dc225&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__